import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import type { ApiToken } from "src/queries/auth/tokens.types";
import { DeleteOutlineIcon, ReplayIcon } from "@ui-icons";
import type { TokenMenuAnchor } from "../../SystemSettingsTokenManagement.types";
import { getTokenStatus } from "../../SystemSettingsTokenManagement.utils";

interface SystemSettingsTokenManagementRowMenuProps {
  menuAnchor: TokenMenuAnchor | null;
  onClose: () => void;
  onRevoke: (token: ApiToken) => void;
  onReactivate: (token: ApiToken) => void;
  onDelete: (token: ApiToken) => void;
}

export default function SystemSettingsTokenManagementRowMenu({
  menuAnchor,
  onClose,
  onRevoke,
  onReactivate,
  onDelete,
}: SystemSettingsTokenManagementRowMenuProps) {
  return (
    <Menu anchorEl={menuAnchor?.el} open={!!menuAnchor} onClose={onClose}>
      {menuAnchor && getTokenStatus(menuAnchor.token) === "active" && (
        <MenuItem onClick={() => void onRevoke(menuAnchor.token)}>
          <ListItemIcon>
            <DeleteOutlineIcon fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText sx={{ color: "error.main" }}>Revoke</ListItemText>
        </MenuItem>
      )}
      {menuAnchor && getTokenStatus(menuAnchor.token) === "revoked" && (
        <>
          <MenuItem onClick={() => void onReactivate(menuAnchor.token)}>
            <ListItemIcon>
              <ReplayIcon fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText>Reactivate</ListItemText>
          </MenuItem>
          <MenuItem onClick={() => void onDelete(menuAnchor.token)}>
            <ListItemIcon>
              <DeleteOutlineIcon fontSize="small" color="error" />
            </ListItemIcon>
            <ListItemText sx={{ color: "error.main" }}>
              Delete permanently
            </ListItemText>
          </MenuItem>
        </>
      )}
    </Menu>
  );
}
